var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "s3" }, [
    !_vm.value
      ? _c("div", [
          _vm.status === "preupload"
            ? _c("div", [
                _c("span", { staticClass: "text" }, [_vm._v("送信準備中...")]),
              ])
            : _vm.status === "uploading"
            ? _c(
                "div",
                {
                  staticClass: "ui indicating progress",
                  attrs: { "data-percent": "0" },
                },
                [
                  _c("div", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.progress) + "%"),
                  ]),
                ]
              )
            : _c("input", {
                attrs: { type: "file", accept: _vm.accept },
                on: {
                  change: function ($event) {
                    return _vm.attach($event.target)
                  },
                },
              }),
        ])
      : _c("div", [
          _vm.value &&
          _vm.value.mime_type &&
          _vm.value.mime_type === "application/pdf"
            ? _c("span", { staticClass: "pdfIcon" }, [
                _c("i", { staticClass: "fas fa-file-pdf" }),
              ])
            : _vm.value && _vm.value.urls.preview
            ? _c("img", { attrs: { src: _vm.value.urls.preview } })
            : _vm.value && _vm.value.urls.small
            ? _c("img", { attrs: { src: _vm.value.urls.small } })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "filename",
              attrs: { title: _vm.value.original_file_name },
            },
            [_vm._v(_vm._s(_vm.value.original_file_name))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "ui mini negative button",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.clear()
                },
              },
            },
            [_vm._v("削除")]
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }